import React from 'react';
import { TileAddOn } from '@tamagoshi/core/Tile';
import Text from '@tamagoshi/core/Text';
import { getTranslations } from '@translations';

import styles from './styles/index.module.scss';

const Chat = () => {
  const translations = getTranslations();

  return (
    <>
      <TileAddOn direction="column">
        <Text type="small" weight="semiBold" className={styles.title}>
          {translations('footer.contact.service.title')}
          <Text tag="span" type="small" className={styles.subHeading}>
            {translations('footer.contact.service.sub.title')}
          </Text>
        </Text>
        <Text type="tiny" className={styles.text}>
          {translations('footer.contact.service.availability.weekdays')} <br />
          {translations('footer.contact.service.availability.weekend')}
        </Text>
      </TileAddOn>
    </>
  );
};

Chat.displayName = 'Chat';

export default Chat;
